import axios from "axios";
import {
  IP
} from "../index.js";
/* 预约地址信息维护 */
export async function selectAddress(data) {
  var resp = await axios.post(`${IP}/admin/nurseAddress/select`, data);
  return resp.data;
}

export async function addAddress(data) {
  var resp = await axios.post(`${IP}/admin/nurseAddress/add`, {
    ...data,
  });
  return resp.data;
}

export async function updateAddress(data) {
  var resp = await axios.post(`${IP}/admin/nurseAddress/update`, {
    ...data,
  });
  return resp.data;
}

export async function deleteAddress(data) {
  var resp = await axios.post(`${IP}/admin/nurseAddress/delete`, data);
  return resp.data;
}

